import * as React from 'react';
import { Link } from 'react-router-dom';
import Flex from '../data/Flex';
import './UIFlex.scss';


export interface IFlex{
    direction?:string;
    inline?:boolean;
    wrap?:boolean;
    wrapRev?:boolean;
    alignItems?:string;
    alignContent?:string;
    justifyContent?:string;
    justifyItems?:string;
    style?:React.CSSProperties;
    elementType?:string;
    overflowHidden?:boolean;
    overflowScrollY?:boolean;
    overflowScrollX?:boolean;
    fullWidth?:boolean;
}

export interface IUIFlexProps extends React.PropsWithChildren {
    className?:string;
    flex?:IFlex;
    onClick?:()=>void;
    onMouseOver?:()=>void;
    onMouseOut?:()=>void;
    path?:string;
}


export const addCN=()=>{
    
}

/**
 * The purpose of this is to allow default settings at each level of abstraction but always provide a way to override
 */
export const copyFlex=($default?:IFlex, $overrides?:IFlex):IFlex=>{
    //let data:IFlex = {...$default, ...$overrides};
    //yes we could just use spread but direct references are faster right?

    return {
        direction:$overrides?.direction || $default?.direction,
        inline:$overrides?.inline || $default?.inline,
        wrap:$overrides?.wrap || $default?.wrap,
        wrapRev:$overrides?.wrapRev || $default?.wrapRev,
        alignItems:$overrides?.alignItems || $default?.alignItems,
        alignContent:$overrides?.alignContent || $default?.alignContent,
        justifyContent:$overrides?.justifyContent || $default?.justifyContent,
        justifyItems:$overrides?.justifyItems || $default?.justifyItems,
        overflowHidden:$overrides?.overflowHidden || $default?.overflowHidden,
        overflowScrollX:$overrides?.overflowScrollX || $default?.overflowScrollX,
        overflowScrollY:$overrides?.overflowScrollY || $default?.overflowScrollY,
        style:$overrides?.style || $default?.style,
        elementType:$overrides?.elementType || $default?.elementType,
        fullWidth:$overrides?.fullWidth || $default?.fullWidth,
    };
}



export default class UIFlex extends React.Component<IUIFlexProps>{

    div:React.RefObject<HTMLDivElement> = React.createRef();
    button:React.RefObject<HTMLButtonElement> = React.createRef();
    form:React.RefObject<HTMLFormElement> = React.createRef();

    static TYPE_DIV:string = "div";
    static TYPE_BUTTON:string = "button";
    static TYPE_FORM:string = "form";

    _formSubmit=()=>{

    }

    render(){
        let cn:string = this.props.className?this.props.className+" flex":"flex";
        cn+=" flex_"+(this.props.flex?.direction || Flex.ROW);
    
        let style:React.CSSProperties = {};
        if(this.props.flex){
            if(this.props.flex.inline)              cn+=" flex_inline";
            if(this.props.flex.wrap)                cn+=" flex_wrap";
            if(this.props.flex.wrapRev)             cn+=" flex_wrap_rev";
            if(this.props.flex.alignItems)          cn+=" flex_alignItems_"+this.props.flex.alignItems;
            if(this.props.flex.alignContent)        cn+=" flex_alignContent_"+this.props.flex.alignContent;
            if(this.props.flex.justifyContent)      cn+=" flex_justifyContent_"+this.props.flex.justifyContent;
            if(this.props.flex.justifyItems)        cn+=" flex_justifyItems_"+this.props.flex.justifyItems;
            if(this.props.flex.style){
                style = this.props.flex.style;
            }

            if(this.props.flex.overflowHidden)      cn+=" overflowHidden";
            if(this.props.flex.overflowScrollX)     cn+=" overflowScrollX";
            if(this.props.flex.overflowScrollY)     cn+=" overflowScrollY";
            if(this.props.flex.fullWidth)           cn+=" fullWidth";
        }
        
        let content:JSX.Element = <></>;

        let elementProps = {            
            style:style,
            className:cn,
        }

        switch(this.props.flex?.elementType){
            case UIFlex.TYPE_BUTTON:
                content = (
                    <button onMouseOver={this.props.onMouseOver} onMouseOut={this.props.onMouseOut}  onClick={this.props.onClick} ref={this.button} {...elementProps}>
                        {this.props.children}
                    </button>
                );
            break;
            case UIFlex.TYPE_FORM:
                content = (
                    <form 
                        onSubmit={($event:React.FormEvent)=>{
                            $event.preventDefault();
                        }} 
                        ref={this.form} 
                        {...elementProps}
                    >
                        {this.props.children}
                    </form>
                );
            break;
            default:

                if(this.props.path){
                    //render as link
                    content = (                        
                        <Link to={this.props.path}  {...elementProps}>
                            {this.props.children}
                        </Link>
                    );
                }else{
                    content = (
                        <div onMouseOver={this.props.onMouseOver} onMouseOut={this.props.onMouseOut} onClick={this.props.onClick} ref={this.div} {...elementProps}>
                            {this.props.children}
                        </div>
                    );
                }

        }

        return content;
    }
}